import MailRow from "@/components/mailsList/MailRow";
import Email, { MailsListId } from "@/domain/entities/emails/Email";
import { isSameCopy } from "@/lib/mailIdentity";
import { Dispatch, RefObject, SetStateAction } from "react";
import { FocusTarget } from "./MailAction";

type EmailListProps = {
    mailsListFlattened: Email[];
    selectedMails: Email[];
    handleCheckboxSelectChange: (checked: boolean, selected: Email) => void;
    squeezeItems: boolean;
    openedMail?: Email;
    openedMailRef?: RefObject<HTMLDivElement | null>;
    listId: MailsListId;
    setMailInputExpanded: (
        mailInputExpanded: boolean,
        focusTarget?: FocusTarget,
    ) => void;
    setSelectedMails: Dispatch<SetStateAction<Email[]>>;
};

const EmailList = ({
    mailsListFlattened,
    selectedMails,
    handleCheckboxSelectChange,
    squeezeItems,
    openedMail,
    openedMailRef,
    listId,
    setMailInputExpanded,
    setSelectedMails,
}: EmailListProps) => (
    <div className="mb-4 flex h-full w-full flex-col gap-1.5">
        {mailsListFlattened.map((mail) => {
            const isOpened = !!openedMail && isSameCopy(openedMail, mail);

            return (
                <MailRow
                    key={mail.uniqueMailvistaId}
                    ref={isOpened ? openedMailRef : undefined}
                    isOpened={isOpened}
                    listId={listId}
                    mail={mail}
                    onSelectChange={handleCheckboxSelectChange}
                    selectedMails={selectedMails}
                    setMailInputExpanded={setMailInputExpanded}
                    setSelectedMails={setSelectedMails}
                    squeeze={squeezeItems}
                />
            );
        })}
    </div>
);

export default EmailList;
